import { ca } from '@cian/analytics';

export function trackCheckDeveloperInfoEvent() {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'to_builder',
    page: {
      siteType: 'desktop',
      pageType: 'ListingCompareJK',
      listingType: 'list',
    },
  });
}
